import { render, staticRenderFns } from "./AutoMadConfig.vue?vue&type=template&id=3ca7fe58&scoped=true&"
import script from "./AutoMadConfig.vue?vue&type=script&lang=js&"
export * from "./AutoMadConfig.vue?vue&type=script&lang=js&"
import style1 from "../../components/style/chat-view.scss?vue&type=style&index=1&id=3ca7fe58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7fe58",
  null
  
)

export default component.exports